export default {
      id: "xtype_checkbox-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "img/icons.svg#xtype_checkbox",
      toString: function () {
        return this.url;
      }
    }